var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "withdraw",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "warning-wrap withdraw-warning"
  }, [_c('i', {
    staticClass: "fa fa-triangle-exclamation"
  })]), _c('div', [_c('h6', {}, [_vm._v("Are you sure you want to "), _c('b', [_vm._v("Withdraw")]), _vm._v(" the selected pending item?")]), _c('p', {
    staticClass: "light-txt"
  }, [_vm._v(" This action is permanent and cannot be undone. The selected members will be removed from the pending list and their status will be updated to \"Withdrawn\". If you're sure, please confirm your decision. ")])])]), _c('div', {
    staticClass: "d-flex justify-content-end flex-column-reverse flex-sm-row mt-3 gap-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _c('b-button', {
    staticClass: "univ-btn m-0 px-5 univ-withdraw",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Withdraw ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }